// TODO: Replace later with real data
export enum Currency {
    CZK = 'CZK',
    EUR = 'EUR',
    GBP = 'GBP',
}
